import { Link } from "react-router-dom";
import { Clock, ArrowRight, CheckCircle2 } from "lucide-react";
import ProgressRing from "./ProgressRing";

export default function ModuleCard({ module, completedCount, totalTopics, delay = 0 }) {
  const pct = totalTopics > 0 ? (completedCount / totalTopics) * 100 : 0;
  const done = completedCount >= totalTopics && totalTopics > 0;

  return (
    <Link
      to={`/module/${module.id}`}
      data-testid={`module-card-${module.id}`}
      className="group relative bg-card border border-border rounded-2xl p-7 flex flex-col gap-5 overflow-hidden animate-fade-up transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[color:hsl(37_92%_50%_/_0.12)] hover:border-brand-amber/40"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div
        className="absolute inset-x-0 top-0 h-1 opacity-80"
        style={{ background: module.accent }}
      />
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-muted-foreground">
            <span
              className="inline-flex items-center justify-center h-6 w-6 rounded-full text-[11px] font-semibold"
              style={{ background: `${module.accent}1a`, color: module.accent }}
            >
              {module.number}
            </span>
            Module
          </div>
          <h3 className="mt-3 font-display text-2xl sm:text-[26px] leading-tight text-balance">
            {module.title}
          </h3>
          <p className="mt-1 text-sm text-muted-foreground">{module.subtitle}</p>
        </div>
        <ProgressRing value={pct} size={56} stroke={5} />
      </div>

      <p className="text-sm leading-relaxed text-muted-foreground line-clamp-3">
        {module.takeaway}
      </p>

      <div className="flex items-center justify-between pt-2 mt-auto">
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1.5">
            <Clock className="h-3.5 w-3.5" />
            {module.hours} hr{module.hours > 1 ? "s" : ""}
          </span>
          <span>•</span>
          <span>
            {completedCount}/{totalTopics} topics
          </span>
        </div>
        <div className="inline-flex items-center gap-1 text-sm font-medium text-brand-amber group-hover:translate-x-0.5 transition-transform">
          {done ? (
            <>
              <CheckCircle2 className="h-4 w-4" /> Done
            </>
          ) : (
            <>
              Start <ArrowRight className="h-4 w-4" />
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
